import { afterNextRender, DOCUMENT, inject, Injector } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

/** Вызывать один раз в корне: без переноса фокуса клавиатура и скринридер остаются на прошлом экране. */
export function useRouteFocus(): void {
  const router = inject(Router);
  const doc = inject(DOCUMENT);
  const injector = inject(Injector);
  let lastPath: string | null = null;

  router.events
    .pipe(
      filter((event) => event instanceof NavigationEnd),
      takeUntilDestroyed(),
    )
    .subscribe((event) => {
      const path = event.urlAfterRedirects.split(/[?#]/)[0];
      const previous = lastPath;
      lastPath = path;
      // Холодная загрузка — фокус и так в начале; смена одного query (табы «Заказов») — фокус у контрола.
      if (previous === null || previous === path) {
        return;
      }
      // Фаза write идёт раньше mixedReadWrite — точечный фокус самой страницы перекроет этот.
      afterNextRender(
        {
          write: () => {
            // Заголовок лежит то внутри <main>, то в app-page-header перед ним — целимся в h1, main как запасной.
            const target = doc.querySelector<HTMLElement>('h1') ?? doc.querySelector('main');
            if (!target) {
              return;
            }
            target.tabIndex = -1;
            // preventScroll: иначе фокус подерётся с восстановлением позиции скролла роутером.
            target.focus({ preventScroll: true });
          },
        },
        { injector },
      );
    });
}
